import React, { useEffect, useState } from 'react';
import { Channel, useChatContext } from 'stream-chat-react';

import './ChannelContainer.css';

import { ChannelInner } from './ChannelInner.jsx';

import { ChannelEmptyState } from '../ChannelEmptyState/ChannelEmptyState.jsx';
import { CreateChannel } from '../CreateChannel/CreateChannel.jsx';
import { EditChannel } from '../EditChannel/EditChannel.jsx';
import { TeamMessageInput } from '../TeamMessageInput/TeamMessageInput.jsx';

import { CloseThreadIcon } from '../../_assets';

const ThreadHeader = (props) => {
  const { closeThread, setPinsOpen, thread } = props;
  const getReplyCount = () => {
    if (!thread?.reply_count) return '';
    if (thread.reply_count === 1) return '1 reply';
    return `${thread.reply_count} Replies`;
  };

  return (
    <div className='custom-thread-header'>
      <div className='custom-thread-header__left'>
        <p className='custom-thread-header__left-title'>Thread</p>
        <p className='custom-thread-header__left-count'>{getReplyCount()}</p>
      </div>
      <CloseThreadIcon {...{ closeThread, setPinsOpen }} />
    </div>
  );
};

export const ChannelContainer = (props) => {
  const {
    createType,
    isCreating,
    isEditing,
    setIsCreating,
    setIsEditing,
    initialChannel,
  } = props;

  const { channel, setActiveChannel } = useChatContext();

  const [pinsOpen, setPinsOpen] = useState(false);

  useEffect(() => {
    if (initialChannel) {
      setActiveChannel(initialChannel);
    }
  }, [initialChannel]);

  if (isCreating) {
    const filters = {};

    return (
      <div className='channel__container'>
        <CreateChannel {...{ createType, filters, setIsCreating }} />
      </div>
    );
  }

  if (isEditing) {
    const filters = {};

    if (channel?.state?.members) {
      const channelMembers = Object.keys(channel.state.members);
      if (channelMembers.length) {
        filters.id = { $nin: channelMembers };
      }
    }

    return (
      <div className='channel__container'>
        <EditChannel {...{ filters, setIsEditing }} />
      </div>
    );
  }

  return (
    <div className='channel__container'>
      <Channel
        EmptyStateIndicator={ChannelEmptyState}
        Input={TeamMessageInput}
        ThreadHeader={(threadProps) => (
          <ThreadHeader {...threadProps} {...{ setPinsOpen }} />
        )}
        TypingIndicator={() => null}
      >
        <ChannelInner
          {...{
            pinsOpen,
            setIsEditing,
            setPinsOpen,
          }}
        />
      </Channel>
    </div>
  );
};
